import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const ASSET_BASE = process.env.PUBLIC_URL || "";

const locations = [
  {
    title: "HONG KONG",
    color: "#c1d82f",
    address: [
      "ANKO Sourcing (Hong Kong) Pty Limited",
      "Room 1009-1011, 1016-1023A, 10/F, Trade Square",
      "681 Cheung Sha Wan Road",
      "Cheung Sha Wan, Kowloon",
      "Hong Kong",
    ],
    phone: "+852 3509 1200",
  },
  {
    title: "SHANGHAI",
    color: "#00a9ce",
    address: [
      "ANKO Sourcing (Shanghai) Limited",
      "Level 6, Yes Commercial Building,",
      "No. 369 Kaixuan Road",
      "Changning District",
      "Shanghai \u2013 200051, PRC",
    ],
    phone: "+86 21 2312 2600",
  },
  {
    title: "DONGGUAN",
    color: "#7a5195",
    address: [
      "ANKO Sourcing (Shanghai) Limited Dongguan Branch",
      "Room 801-803, 8/F,",
      "Zhi Xing International Commerce Building,",
      "Railway Garden Crossing Changping Road,",
      "Changping Town, Dongguan City",
      "Guangdong Province \u2013 523560, PRC",
    ],
    phone: "+86 21 2312 2600",
  },
  {
    title: "BANGLADESH",
    color: "#005a70",
    address: [
      "ANKO Sourcing (Bangladesh) Private Limited",
      "2nd Floor (North West Corner \u2013 Office Block 2)",
      "Le Meridien Dhaka Hotel Cum Office Complex 79/A",
      "Commercial Area Airport Road,",
      "Nikunja-02, Khilkhet",
      "Dhaka-1229, Bangladesh",
    ],
    phone: "+880 96 1012 7979",
  },
  {
    title: "INDIA",
    color: "#ee5a0a",
    address: [
      "ANKO Sourcing (India) Private Limited",
      "11th Floor, Building No. 9B",
      "DLF Cyber City, DLF Phase-III",
      "Gurgaon-122002",
      "Haryana India",
    ],
    phone: "+91 124 4915100",
  },
  {
    title: "INDONESIA",
    color: "#b80b70",
    address: [
      "Kmart Australia Limited \u2013 Indonesia Representative Office",
      "Citi Hub, Harton Tower, Level 3, Unionspace,",
      "Jl. Sentra Bisnis, Artha Gading Kav D no 3,",
      "Kelapa Gading, North Jakarta",
      "Jakarta 14240, Indonesia",
    ],
    phone: "+62 21 3111 8111",
  },
  {
    title: "SINGAPORE",
    color: "#0ec8ce",

    address: [
      "Anko Sourcing (Singapore) Pte. Ltd.",
      "6 Battery Road, #03-01",
      "Singapore 049909",
    ],
  },
  {
    title: "VIETNAM",
    color: "#11d33b",

    address: [
      "Vo Thi Sau Street, District 3",
      "Ho Chi Minh City \u2013 722700,",
      "Vietnam",
    ],
  },
];

function ContactUs() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <Box component="main">
      <Box
        component="section"
        sx={{
          position: "relative",
          width: "100%",
          height: { xs: "30vh", md: "40vh" },
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${ASSET_BASE}/assets/Contactbg.png)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <Box
          sx={{
            position: "relative",
            top: "50%",
            left: { xs: "24px", md: "64px" },
            transform: "translateY(-50%)",
            color: "common.white",
            zIndex: 2,
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "2.7rem", md: "3.5rem", lg: "4rem" },
              fontWeight: 700,
              lineHeight: 1.1,
              m: 0,
              textShadow: "0 2px 10px rgba(0,0,0,0.3)",
            }}
          >
            Contact Us
          </Typography>
        </Box>
      </Box>

      <Box
        component="section"
        sx={{
          py: { xs: 8, md: 12 },
          px: { xs: 3, md: 10 },
          bgcolor: "#fff",
        }}
      >
        <Typography
          variant="h2"
          sx={{
            textAlign: "left",
            mb: { xs: 6, md: 12 },
            fontWeight: 300,
            fontSize: { xs: "2.5rem", md: "3.5rem" },
          }}
        >
          Our Locations
        </Typography>

        <Box
          sx={{
            maxWidth: 1400,
            mx: "auto",
            position: "relative",
            p: { xs: 4, md: "80px 120px" },
          }}
        >
          {(() => {
            const cornerSize = { xs: 40, md: 70 };
            const borderStyle = "6px solid #b01273";

            return (
              <>
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: cornerSize,
                    height: cornerSize,
                    borderTop: borderStyle,
                    borderLeft: borderStyle,
                  }}
                />

                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    width: cornerSize,
                    height: cornerSize,
                    borderTop: borderStyle,
                    borderRight: borderStyle,
                  }}
                />

                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: cornerSize,
                    height: cornerSize,
                    borderBottom: borderStyle,
                    borderLeft: borderStyle,
                  }}
                />

                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    width: cornerSize,
                    height: cornerSize,
                    borderBottom: borderStyle,
                    borderRight: borderStyle,
                  }}
                />
              </>
            );
          })()}

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, 1fr)",
              },
              columnGap: { md: "80px" },
              rowGap: { xs: 6, md: 8 },
            }}
          >
            {locations.map((loc, i) => (
              <Box
                key={i}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  "&:hover .icon-bounce": { transform: "scale(1.3)" },
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 800,
                    mb: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    fontSize: { xs: "1.7rem", md: "1.85rem", lg: "2rem" },
                    color: "#000",
                  }}
                >
                  <Box
                    className="icon-bounce"
                    sx={{
                      position: "relative",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition:
                        "transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                    }}
                  >
                    <LocationOnIcon sx={{ fontSize: 38, color: loc.color }} />
                    <Box
                      sx={{
                        position: "absolute",
                        top: "20%",
                        width: 10,
                        height: 10,
                        bgcolor: "white",
                        borderRadius: "50%",
                      }}
                    />
                  </Box>
                  {loc.title}
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    lineHeight: 1.8,
                    color: "#888",
                    fontSize: { xs: "0.95rem", md: "0.9rem", lg: "1rem" },
                    fontWeight: 400,
                  }}
                >
                  {loc.address.map((line, j) => {
                    if (j === 0) {
                      return (
                        <span
                          key={j}
                          style={{
                            fontWeight: 550,
                            color: "#666",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {line}
                          <br />
                        </span>
                      );
                    }
                    return (
                      <span key={j}>
                        {line}
                        <br />
                      </span>
                    );
                  })}
                </Typography>

                {loc.phone && (
                  <Typography
                    variant="body1"
                    sx={{
                      mt: 2,
                      fontWeight: 500,
                      color: "#888",
                      fontSize: { xs: "0.95rem", md: "0.9rem", lg: "1rem" },
                    }}
                  >
                    Phone: {loc.phone}
                  </Typography>
                )}
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default ContactUs;
